import React, { useEffect, useRef, useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";

import { Button, Col, Divider, Dropdown, Icon, Input, Menu, message, Modal, Row, Table, Typography, Upload, Select, Tag } from "antd";

import Loader from "components/Loader/Loader";
// import FloatingActionButton from "components/FloatingActionButton/FloatingActionButton";

import emptyImage from "../../media/empty-survey-list.svg";

import {
	archiveCohortApi,
	createCohortApi,
	deleteCohortApi,
	fetchCohortAdminListApi,
	fetchCohortCountApi,
	importCohortApi,
	updateCohortNameApi,
} from "utils/apiService";
import moment from "moment";

const { Text } = Typography;
const { Dragger } = Upload;

const CohortsTable = (props) => {
	const { data } = props;


	const [deleteModal, setDeleteModal] = useState(false);
	const deleteCohort = useRef("");

	const [updateModal, setUpdateModal] = useState(false);
	const updateCohort = useRef({
		name: "",
		uuid: "",
	});

	const columns = [
		{
			title: "Cohort Name",
			dataIndex: "name",
			key: "cohortName",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data || "-"}
					</Text>
				);
			},
		},
		{
			title: "Cohort Type",
			dataIndex: "cohort_type",
			key: "cohort_type",
			render: (type) => (type === "ST" ? <Tag color="green">Store</Tag> : (type==="MN"?<Tag color="orange">Main</Tag>:<Tag color="blue">Common</Tag>)),
		},
		{
			title: "No. of Customers",
			dataIndex: "user_count",
			key: "customerCount",
			render: (data) => {
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data || "0"}
					</Text>
				);
			},
		},
		{
			title: "Created On",
			dataIndex: "date_created",
			key: "createdOn",
			render: (data) => {
				//format date in dd mmm yyyy using moment
				const date = new Date(data * 1000);
				
				return (
					<Text
						style={{
							fontStyle: "normal",
							fontWeight: "bold",
							fontSize: "16px",
							lineHeight: "24px",
							color: "#181818",
							whiteSpace: "nowrap",
						}}>
						{data ? data : "-"}
					</Text>
				);
			},
		},
		{
			title: "",
			dataIndex: ["uuid", "name","cohort_type"],
			key: "uuid",
			render: (_, row) => {
				return (
					<div style={{ width: "16px" }}>
						{ row.cohort_type === "CO" && <Dropdown
							placement={"bottomLeft"}
							onClick={(e) => {
								e.stopPropagation();
							}}
							style={{ marginLeft: "0" }}
							overlay={
								<Menu>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											updateCohort.current = { uuid: row.uuid, name: row.name };
											setUpdateModal(true);
										}}>
										<Text style={{ color: "#181818" }}>Rename Cohort</Text>
									</Menu.Item>
									<Menu.Item
										onClick={(e) => {
											e.domEvent.stopPropagation();
											archiveCohortApi({
												requestData: {
													uuid: row.uuid,
													status: props.noAction ? "unarchive" : "archive",
												},
												res200Callback: () => {
													props.updatePage(data.pageNum);
												},
											});
										}}>
										<Text style={{ color: "#181818" }}>{props.noAction ? "Unarchive" : "Archive"}</Text>
									</Menu.Item>
									{/* {row.name !== "Cohort1" && (
										<Menu.Item
											onClick={(e) => {
												e.domEvent.stopPropagation();
												deleteCohort.current = row.uuid;
												setDeleteModal(true);
											}}>
											<Text style={{ color: "#F5222D" }}>Delete</Text>
										</Menu.Item>
									)} */}
								</Menu>
							}>
							<Icon
								type="more"
								onClick={(e) => {
									e.stopPropagation();
								}}
								style={{
									fontSize: "16px",
									color: "#747474",
									marginLeft: "52px",
								}}
							/>
						</Dropdown>}
					</div>
				);
			},
		},
	];

	return (
		<>
			<Table
				// rowSelection={props.noAction ? null : rowSelection}
				columns={(function () {
					// if (props.noAction) {
					// 	return columns.filter((item) => item.key != "x");
					// }
					return columns;
				})()}
				dataSource={data.cohorts}
				pagination={{ showQuickJumper: true, pageSize: data.pageSize }}
				style={{ overflow: "none" }}
				onChange={(pagination) => {
					props.updatePage(pagination.current);
				}}
				onRow={(obj) => ({
					onClick: () => {
						props.history.push(`${props.location?.pathname}/${obj?.uuid}`);
					},
				})}
				loading={props.loading}
			/>
			<Modal centered visible={updateModal} destroyOnClose maskClosable={false} onCancel={() => setUpdateModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="edit"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Change Cohort Name
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<div>
							<Text
								style={{
									fontSize: "14px",
									color: "#181818",
									fontWeight: "bold",
									// fontWeight:"bold"
								}}>
								Cohort Name
							</Text>
							<Input
								className="time-value-cohort-col-main-element"
								style={{ width: "100%", marginTop: "8px" }}
								placeholder="Enter a cohort name"
								defaultValue={updateCohort.current.name}
								onChange={(e) => {
									updateCohort.current.name = e.target.value;
								}}
							/>
						</div>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "5px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setUpdateModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "5px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
								}}
								onClick={() => {
									updateCohortNameApi({
										requestData: updateCohort.current,
										res200Callback: () => {
											setUpdateModal(false);
											props.updatePage(data.pageNum);
										},
									});
								}}>
								Update
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
			<Modal centered visible={deleteModal} destroyOnClose maskClosable={false} onCancel={() => setDeleteModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="delete"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Delete item
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						<Col span={24}>
							<Text>Are you sure you want to delete this Cohort?</Text>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={18}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
								}}
								onClick={() => setDeleteModal(false)}>
								Cancel
							</Button>
						</Col>
						<Col
							style={{
								marginTop: "60px",
								textAlign: "right",
							}}
							span={6}>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#C91713",
									color: "#FFFFFF",
								}}
								onClick={() => {
									deleteCohortApi({
										requestData: {
											uuid: deleteCohort.current,
										},
										res200Callback: () => {
											setDeleteModal(false);
											props.updatePage(data.pageNum);
										},
									});
								}}>
								Delete
							</Button>
						</Col>
					</Row>
				</Row>
			</Modal>
		</>
	);
};

const CohortList = (props) => {
	let { path } = useRouteMatch();
	const [loading, setLoading] = useState(true);
	const [tableLoading, setTableLoading] = useState(true);
	const [importModal, setImportModal] = useState(false);
	const [activeTab, setActiveTab] = useState(path === "/cohorts" ? "all" : "archived");

	const [cohortImportFile, setCohortImportFile] = useState(null);
	const [importMode, setImportMode] = useState(false);
	const addCohortManually = useRef({
		name: "",
		customer_list: [],
	});

	const [cohortList, setCohortList] = useState({
		cohorts: [],
		pageNum: 1,
		pageSize: 50,
		totalPages: 1,
	});
	const [cohortCounts, setCohortCounts] = useState({
		active: 0,
		archived: 0,
	});

	const loadTable = () => {
		fetchCohortAdminListApi({
			requestData: {
				page: cohortList.pageNum,
				status: activeTab === "archived" ? "archived" : "active",
			},
			resCallback: () => {
				// loading && setLoading(false);
				setTableLoading(false);
			},
			res200Callback: (res) => {
				setCohortList({
					...cohortList,
					cohorts: res.data.cohort_list,
					totalPages: res.data.total_pages,
				});
			},
		});
		fetchCohortCountApi({
			requestData: {},
			resCallback: () => {
				loading && setLoading(false);
			},
			res200Callback: (res) => {
				setCohortCounts({
					archived: res.data.archived,
					active: res.data.active,
				});
			},
		});
	};

	const addCohort = () => {
		if (importMode) {
			message.info("Creating cohorts please wait...");
			let formData = new FormData();
			if (cohortImportFile) {
				formData.append("name", addCohortManually?.current?.name);
				formData.append("file", cohortImportFile);
				importCohortApi({
					requestData: formData,
					resCallback: () => {},
					res200Callback: () => {
						message.success("Cohorts imported successfully.");
						loadTable();
						setImportModal(false);
					},
					resErrorCallback: () => {
						message.error("Failed importing the cohort!");
					},
				});
			}
		} else {
			message.info("Creating cohorts please wait...");
			createCohortApi({
				requestData: addCohortManually.current,
				resCallback: () => {},
				res200Callback: () => {
					message.success("Cohort created successfully.");
					loadTable();
					setImportModal(false);
				},
				resErrorCallback: () => {
					message.error("Failed creating the cohort!");
				},
			});
		}
	};

	useEffect(() => {
		loadTable();
	}, [activeTab]);

	return loading ? (
		<Row type="flex" align="middle" justify="center" style={{ marginTop: "200px" }}>
			<Loader />
		</Row>
	) : (
		<>
			{cohortCounts.active + cohortCounts.archived === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						backgroundColor: "#FAFAFA",
						height: "100vh",
					}}>
					<img width={"600px"} src={emptyImage} alt="Illustration for empty cohort list" />
					<Text
						style={{
							fontSize: "20px",
							color: "#181818",
							fontWeight: "bold",
							marginTop: "16px",
						}}>
						You have not created any cohorts yet.
					</Text>
					<Text style={{ color: "#747474", marginTop: "8px", textAlign: "center" }}>Cohort list will appear hear!</Text>
					<Button
						size={"large"}
						onClick={() => setImportModal(true)}
						style={{
							marginTop: "24px",
							backgroundColor: "#fec708",
							color: "#FFFFFF",
							border: "none",
							borderRadius: "5px",
						}}>
						Create Cohort
					</Button>
				</div>
			) : (
				<>
					<Row
						style={{
							width: "100%",
							padding: "40px 25px 70px",
							margin: "60px auto 20px",
							backgroundColor: "#FAFAFA",
						}}
						gutter={[12, 48]}>
						<Row type="flex" align="middle" justify="space-between">
							<Text
								style={{
									color: "#181818",
									/*fontFamily: "Gotham",*/ fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "24px",
									lineHeight: "39px",
								}}>
								Cohort Management
							</Text>
							<Button
								onClick={() => setImportModal(true)}
								style={{
									display: "flex",
									alignItems: "center",
									padding: "8px 16px",
									color: "#FFFFFF",
									fontSize: "16px",
									lineHeight: "24px",
									background: "#fec708",
									borderRadius: "5px",
									height: "100%",
									margin: "0 0 0 12px",
								}}>
								<Icon
									type="plus"
									style={{
										height: "16px",
									}}
								/>
								Create Cohort
							</Button>
						</Row>
						<Menu selectedKeys={activeTab} onSelect={(e) => setActiveTab(e.key)} mode="horizontal" style={{ backgroundColor: "transparent" }}>
							<Menu.Item key="all">
								{/* <Link to={`${url}`}> */}
								Active {`(${cohortCounts.active})`}
								{/* </Link> */}
							</Menu.Item>
							<Menu.Item key="archived">
								{/* <Link to={`${url}/archived`}> */}
								Archived {`(${cohortCounts.archived})`}
								{/* </Link> */}
							</Menu.Item>
						</Menu>
						<CohortsTable
							{...props}
							loading={tableLoading}
							data={cohortList}
							updatePage={(currentPage) => {
								setCohortList({ ...cohortList, pageNum: currentPage });
								loadTable();
							}}
							noAction={activeTab === "archived"}
						/>
					</Row>
				</>
			)}
			<Modal centered visible={importModal} destroyOnClose maskClosable={false} onCancel={() => setImportModal(false)} footer={null}>
				<Row className="modal-row">
					<Row>
						<Icon
							type="cluster"
							style={{
								color: "#181818",
								fontSize: "24px",
								marginRight: "16px",
							}}
						/>
						<Text
							style={{
								fontWeight: "bold",
								color: "#181818",
								fontSize: "24px",
							}}>
							Create New Cohort
						</Text>
					</Row>
					<Row style={{ marginTop: "24px" }}>
						{importMode ? (
							<div>
								<div>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Cohort Name
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Enter a cohort name"
										onChange={(e) => {
											addCohortManually.current.name = e.target.value;
										}}
									/>
								</div>
								<Row type="flex" align="middle" justify="space-between" style={{ marginTop: "40px" }}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
										}}>
										Upload Customer List
									</Text>
									<a
										href="http://s3-eu-central-1.amazonaws.com/reward-app/sample_files/Cohort_Sample_File.xlsx"
										download
										style={{
											color: "#fec708",
											fontStyle: "normal",
											fontWeight: "normal",
											fontSize: "12px",
											lineHeight: "18px",
										}}>
										<Icon type="download" style={{ marginRight: "8px" }} />
										Download Sample File
									</a>
								</Row>
								<Dragger
									name="file"
									accept=".xlsx"
									multiple={false}
									style={{
										marginTop: "8px",
										width: "100%",
										border: "1px solid rgb(0, 0, 0, 0.25)",
										borderRadius: "5px",
										background: "transparent",
									}}
									bordered={true}
									showUploadList={{
										showDownloadIcon: false,
									}}
									customRequest={({ file, onSuccess }) => {
										setTimeout(() => {
											onSuccess("ok");
										}, 0);
									}}
									onChange={(info) => {
										const { status } = info.file;
										if (status === "done") {
											setCohortImportFile(info.fileList[0]?.originFileObj);
										} else if (status === "error") {
											message.error(`${info.file.name} file upload failed.`);
										}
									}}
									defaultFileList={cohortImportFile ? [cohortImportFile] : []}>
									<Row type="flex" justify="center" align="middle" style={{ flexDirection: "column" }}>
										<Icon
											type="cloud-upload"
											style={{
												color: "#E5E5E5",
												fontSize: "48px",
												marginBottom: "24px",
											}}
										/>
										<Text
											style={{
												fontStyle: "normal",
												fontWeight: "normal",
												fontSize: "14px",
												lineHeight: "22px",
												color: "#181818",
												marginBottom: 8,
											}}>
											Drag & drop file or browse file to upload
										</Text>
										<Text>Only XLSX file format is supported.</Text>
									</Row>
								</Dragger>
							</div>
						) : (
							<div>
								<div>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Cohort Name
									</Text>
									<Input
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Enter a cohort name"
										onChange={(e) => {
											addCohortManually.current.name = e.target.value;
										}}
									/>
								</div>
								<div style={{ marginTop: 40 }}>
									<Text
										style={{
											fontSize: "14px",
											color: "#181818",
											fontWeight: "bold",
											// fontWeight:"bold"
										}}>
										Customer Phone Numbers
									</Text>
									<Select
										mode="tags"
										className="time-value-cohort-col-main-element"
										style={{ width: "100%", marginTop: "8px" }}
										placeholder="Enter customer phone numbers"
										tokenSeparators={[",", " "]}
										onChange={(e) => {
											if (
												(e?.length !== 0 &&
													JSON.parse(localStorage.getItem("countryData"))?.short_name === "AE" &&
													e[e?.length - 1]?.length === 12) ||
												(JSON.parse(localStorage.getItem("countryData"))?.short_name === "IN" && e[e?.length - 1]?.length === 12)
											) {
												addCohortManually.current.customer_list = e;
											} else {
												message.info("Incorrect contact number");
											}
										}}
									/>
								</div>
							</div>
						)}
						<Divider>OR</Divider>
						<div style={{ textAlign: "center" }}>
							<Text
								style={{
									fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "16px",
									lineHeight: "24px",
									color: "#fec708",
									cursor: "pointer",
								}}
								onClick={() => setImportMode(!importMode)}>
								{importMode ? "Create Manually" : "Import Sheet"}
							</Text>
						</div>
						<Row
							type="flex"
							justify="end"
							align="middle"
							style={{
								marginTop: "40px",
							}}>
							<Button
								size="large"
								style={{
									height: "40px",
									boxShadow: "none",
									borderRadius: "20px",
									border: "none",
									backgroundColor: "#FFFFFF",
									color: "#181818",
									marginRight: "12px",
								}}
								onClick={() => setImportModal(false)}>
								Cancel
							</Button>
							<Button
								size="large"
								style={{
									height: "40px",
									borderRadius: "2px",
									border: "none",
									backgroundColor: "#fec708",
									color: "#FFFFFF",
								}}
								onClick={addCohort}>
								Create Cohort
							</Button>
						</Row>
					</Row>
				</Row>
			</Modal>
		</>
	);
};

export default CohortList;
